import * as React from "react"
import NavBar from "../../components/NavBar";
import {useTranslation} from "react-i18next";
import {Link, useLocation, useSearchParams} from "react-router-dom";
import {handleSetQuery} from "../../assets/js/main";
import {Add} from "@mui/icons-material";


export default function Representation() {
  const {t} = useTranslation()
  const location = useLocation();


  return (
     <>
       <NavBar/>

       <div className="representationPage">
         <div className="container">
           <div className="row">
             <div className="col-12">
               <h2>{t("representation.t1")}</h2>
               <p>{t("representation.t2")}</p>

               <h4>{t("representation.t3")}</h4>
               <ul>
                 <li>{t("representation.t4")}</li>
                 <li>{t("representation.t5")}</li>
                 <li>{t("representation.t6")}</li>
                 <li>{t("representation.t7")}</li>
                 <li>{t("representation.t8")}</li>
                 <li>{t("representation.t9")}</li>
               </ul>

               <h4>{t("representation.t10")}</h4>
               <ul>
                 <li>{t("representation.t11")}</li>
                 <li>{t("representation.t12")}</li>
                 <li>{t("representation.t13")}</li>
                 <li>{t("representation.t14")}</li>
                 <li>{t("representation.t15")}</li>
                 <li>{t("representation.t16")}</li>
                 <li>{t("representation.t17")}</li>
               </ul>

               <h4>{t("representation.t18")}</h4>
               <ul>
                 <li>{t("representation.t19")}</li>
                 <li>{t("representation.t20")}</li>
                 <li>{t("representation.t21")}</li>
                 <li>{t("representation.t22")}</li>
               </ul>
             </div>

             <div className="col-12 col-md-6 col-lg-4 link">
               <a href="https://postex.ir/images/uploaded/shipito/contract.pdf" target="_blank">{t("representation.t23")}</a>
             </div>
             <div className="col-12 col-md-6 col-lg-4 link">
               <a href="https://postex.ir/images/uploaded/PostBar/05%20%D8%A7%D8%AE%D8%B0%20%D9%86%D9%85%D8%A7%DB%8C%D9%86%D8%AF%DA%AF%DB%8C%20postbar/971112%20%D8%B3%D9%81%D8%AA%D9%87%20%DB%8C%DA%A9%20%D9%85%DB%8C%D9%84%DB%8C%D8%A7%D8%B1%D8%AF%20%D8%B1%DB%8C%D8%A7%D9%84%DB%8C.pdf" target="_blank">{t("representation.t24")}</a>
             </div>
             <div className="col-12 col-md-6 col-lg-4 link">
               <a href="https://postex.ir/images/uploaded/PostBar/05%20%D8%A7%D8%AE%D8%B0%20%D9%86%D9%85%D8%A7%DB%8C%D9%86%D8%AF%DA%AF%DB%8C%20postbar/%D8%AC%D8%AF%D9%88%D9%84%20%DA%A9%D9%85%DB%8C%D8%B3%DB%8C%D9%88%D9%86%20%D9%88%20%D9%82%DB%8C%D9%85%D8%AA%20%D8%AA%D9%85%D8%A7%D9%85%20%D8%B4%D8%AF%D9%87%20%D8%AE%D8%AF%D9%85%D8%A7%D8%AA%20%D9%BE%D8%B3%D8%AA%20980616.docx" target="_blank">{t("representation.t25")}</a>
             </div>


             <div className="col-12 mt-5">
               <div className="_btnGroup_yellow">
                 <Link to={{pathname: '/singleOrder', search: location?.search}} type="button" className="btnFill">
                   <span>{t("about.t9")}</span>
                   <Add/>
                 </Link>
               </div>
             </div>
           </div>
         </div>
       </div>
     </>
  )
}
